// A stand-in broadcast for the home page: /?booth=demo draws the hero the way
// it looks while Greg's on the air, with a still from a past night where his
// live picture goes, so the design can be seen (and shown to Greg) with nobody
// on the air. Nothing here reaches the booth: no poll, no stream, no counts.

export const isDemo = () =>
  typeof window !== "undefined" &&
  new URLSearchParams(window.location.search).get("booth") === "demo";

const now = Date.now();
const ago = (min, s = 0) => now - min * 60_000 - s * 1000;

const town = (t, n) => ({ k: t.toLowerCase().replace(/\W+/g, "-"), t, n });

const say = (id, name, from, text, min, extra = {}) => ({
  id,
  at: ago(min),
  name,
  from,
  text,
  q: false,
  cheers: 0,
  status: "",
  doneAt: 0,
  edited: false,
  ...extra,
});

export const DEMO_POSTER = "/assets/booth/sweater-night.jpg";

export const DEMO_STATE = {
  live: true,
  startedAt: ago(47, 12),
  gamePk: 849799,
  mode: "game",
  title: "",
  note: "",
  onAir: null,
  wall: [],
  viewers: 214,
  poll: null,
  react: [],
  towns: [
    town("Olathe", 31),
    town("Omaha", 17),
    town("St. Louis", 9),
    town("Toronto", 6),
    town("Lee's Summit", 5),
    town("Wichita", 5),
    town("Kansas City", 4),
    town("Milwaukee", 4),
    town("Tampa", 3),
    town("Phoenix", 2),
    town("Chattanooga", 2),
    town("Denver", 1),
    town("Lawrence", 1),
    town("Chicago", 1),
  ],
  hello: null,
  story: null,
  away: false,
  muted: false,
  brb: false,
  show: null,
  classic: null,
  fact: null,
  line: [],
  guest: null,
  caller: null,
  callWait: 0,
  stands: {
    msgs: [
      say("d1", "Pat", "Toronto", "Watching from Canada tonight. Hi Greg!", 9),
      say("d2", "Terry", "Lee's Summit", "Misiorowski is dealing", 6),
      say("d3", "Carol", "Wichita", "Greg can you show the ring again", 4, { q: true, cheers: 7 }),
      say("d4", "Mike", "Omaha", "That pine tar story never gets old", 3),
      say("d5", "Dana", "Olathe", "Who's the best glove you ever played next to?", 2, {
        q: true,
        cheers: 4,
      }),
      say("d6", "Ron", "Kansas City", "Bottom 5, let's hold them right here", 1),
    ],
    count: 212,
    on: { id: "d3", since: ago(1), until: now + 60_000 },
    headed: "d5",
    seq: 212,
    off: false,
    nextAt: 0,
  },
  now,
  whep: null,
  streamReady: true,
};

export const DEMO_GAME = {
  ok: true,
  game: {
    pk: 849799,
    type: "W",
    state: "Live",
    detailed: "In Progress",
    series: "World Series",
    gameNo: 5,
    seriesStatus: "MIL leads 3-1",
    venue: "Tropicana Field",
    city: "St. Petersburg",
    tv: "FOX / FOX ONE",
  },
  teams: {
    away: { id: 158, abbr: "MIL", club: "Brewers", city: "Milwaukee", name: "Milwaukee Brewers" },
    home: { id: 139, abbr: "TB", club: "Rays", city: "Tampa Bay", name: "Tampa Bay Rays" },
  },
  line: {
    away: { runs: 2, hits: 5, errors: 0 },
    home: { runs: 1, hits: 4, errors: 1 },
  },
  sit: {
    inning: 5,
    ordinal: "5th",
    half: "Bottom",
    isTop: false,
    outs: 1,
    balls: 0,
    strikes: 0,
    battingSide: "home",
    between: false,
  },
};
